import { connectXAppWrapper } from '@core/components';
import { getRaccoonModule, paths } from '@modules/raccoon';
import 'styles/base.scss';
import { getImportsElement } from '@modules/raccoon/src/api/getImportsElement';

export default connectXAppWrapper({
  homePath: paths.RaportyStartowePage,
  modules: [
    getRaccoonModule({
      pimOnly: false,
      dynamicNavItemsProviders: [getImportsElement]
    })
  ]
});

// prod ci test v2
